export default __webpack_public_path__ + "static/media/cinderblock-400.c0df371b.woff2";